/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import './SceneExplore.scss'

import HotspotPlacementTool from './HotspotPlacementTool'

const SceneExplore = props => {

    const data = props.data;
    // {
    //     hotspots: [
    //         {
    //             class: "some-class",
    //             globalReveal:"test reveal 1",
    //             localReveal:"some local text 1",
    //             style: {
    //                 top: 30,
    //                 left: 50,
    //                 width: 100,
    //                 height: 200,
    //             }
    //         },
    //         {
    //             class: "some-class",
    //             globalReveal:"test reveal 2",
    //             localReveal:"some local text 2",

    //             style: {
    //                 top: 190,
    //                 left: 350,
    //                 width: 100,
    //                 height: 100,
    //             }
    //         }
    //     ]
    // }

    const [currentHotspotIndex, setCurrentHotspotIndex] = useState(-1);
    const [hasBeenClicked, setHasBeenClicked] = useState(data.hotspots.map(() => false));
    // eslint-disable-next-line no-unused-vars
    const [editIndex, setEditIndex] = useState(-1);

    

    const handleHotspotClick = (hotspotIndex) => {
        setCurrentHotspotIndex(hotspotIndex)
    }

    const closeReveal = (e) => {
        console.log('click')
        e.preventDefault();
        e.stopPropagation();
        setCurrentHotspotIndex(-1);
    }

    useEffect(() => {
        let temp = _.cloneDeep(hasBeenClicked)
        if (currentHotspotIndex !== -1 && !hasBeenClicked[currentHotspotIndex]) {
            temp[currentHotspotIndex] = true;
            setHasBeenClicked(temp)
        }
        if (props.onChange) {
            props.onChange(temp, currentHotspotIndex)
        }
    }, [currentHotspotIndex])

    useEffect(()=>{
        setCurrentHotspotIndex(-1)
    }, [props.resetScene])

    const topBreakpoint = 200;
    const leftBreakpoint = 350;


    return (
        <div className="SceneExplore">
           
            {/* <div className={`debug`}>
                <input type="number" value={editIndex} onChange={e=>setEditIndex(parseInt(e.target.value))}/>
            </div> */}
            <div className="scene-shadow"></div>
            <div className={`background scene-bg ${data.class}`}>               

                {!props.introOpen && <div className={`hotspots`}>
                    {/* <HotspotPlacementTool target={'.scene-bg'}/> */}
                    {
                        data.hotspots.map((hotspot, hotspotIndex) => {
                            const current = hotspotIndex === currentHotspotIndex;
                            if(editIndex === hotspotIndex){
                                return <HotspotPlacementTool style={hotspot.style} target={'.scene-bg'}/>
                            }                           
                            return <div
                                key={`hotspot-${hotspotIndex}`}
                                className={`hotspot ${hotspot.class} ${current ? 'selected' : 'not-selected'}  ${!current && currentHotspotIndex != -1 ? 'hide' : ''} ${hasBeenClicked[hotspotIndex] ? 'visited' : ''}`}                                
                                style={hotspot.style}
                                // style={{'--total-hotspots':  data.hotspots.length}}
                                onClick={() => handleHotspotClick(hotspotIndex)}>
                                {current && <div className={`reveal ${hotspot.style.left > leftBreakpoint ? 'right' : 'left'} ${hotspot.style.top > topBreakpoint ? 'above' : 'below'}`} >
                                    <div className={`text`} dangerouslySetInnerHTML={{ __html: hotspot.localReveal }}></div>
                                    <div className={`close-btn`} onClick={e => closeReveal(e)}></div>
                                    </div>}
                            </div>
                        })
                    }
                </div>}

                {data.hotspots[currentHotspotIndex] && <div className={`global-reveal`} dangerouslySetInnerHTML={{ __html: data.hotspots[currentHotspotIndex].globalReveal }}></div>}
            </div>

        </div>
    )
}

export default SceneExplore